import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import Swal from 'sweetalert2';
///IDIOMAS
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import {Router,ActivatedRoute} from "@angular/router";
import { Requerimientos3Service } from "app/main/pagina/tools/requerimientos3/requerimientos3.service";
import {Base64} from 'js-base64';
@Component({
  selector: 'app-new-rtdominios',
  templateUrl: './new-rtdominios.component.html',
  styleUrls: ['./new-rtdominios.component.scss']
})
export class NewRTDominiosComponent implements OnInit {

  ///Dominios
  newsurvey:boolean=false;
  forAllGptw:boolean=false;
  graphics04:boolean=false;
  culture04:boolean=false;
  idiomasRtInstituto="";
  parametroProductoId: string;
  idInstituto: string;
  // surveySubDomain:any;
  // ipPublic:any;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private reqService: Requerimientos3Service,

  ) {

    lang_requerimientos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_dispatch.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    localStorage.setItem('ToolbarExterno','ToolbarExterno');
    this.activatedRoute.params.subscribe(params => {
      console.log(params);

        this.parametroProductoId = params.id;
        this.idInstituto = params.idInstituto;
        this.idiomasRtInstituto=this.idInstituto
        // this.surveySubDomain=Base64.decode(params.surveySubDomain);
        // this.ipPublic=Base64.decode(params.ipPublic);
        //   console.log('surveySubDomain',this.surveySubDomain);
        //   console.log('ipPublic',this.ipPublic);
    });
   }


  ngOnInit() {
    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true },
        toolbar  : {hidden: false },
        footer   : {hidden: false },
        sidepanel: {hidden: true }
      }
    }
  }

 //
 //  verificarConexion(tipoConexion){
 //    this.modalConection();
 //         var pingserver = new Image();
 //         let datos:any;
 //    switch (tipoConexion) {
 //      case 1:
 //      pingserver.src = "https://newsurvey.culturalgo.com/FondoITBM.jpg";
 //      if (pingserver.height>0) {
 //    } else {
 //        console.log("no hace nada ");
 //
 //         }
 // setTimeout(() => {
 //   pingserver.src = "https://newsurvey.culturalgo.com/FondoITBM.jpg";
 //   if (pingserver.height>0) {
 //     this.newsurvey=true;
 //  Swal.close();
 //  this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');
 //   } else {
 //     console.log("no hace nada despues del setTime ");
 // Swal.close();
 //      }
 // }, 2000);
 //
 //
 //        break;
 //      case 2:
 //      pingserver.src = "https://urlservices.culturalgo.com/FondoITBM.jpg";
 //      if (pingserver.height>0) {
 //     } else {
 //         console.log(' no hace nada ');
 //
 //      }
 //      setTimeout(() => {
 //        pingserver.src = "https://urlservices.culturalgo.com/FondoITBM.jpg";
 //        if (pingserver.height>0) {
 // this.forAllGptw=true;
 //   Swal.close();
 //   this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');
 //        } else {
 //          console.log("no hace nada despues del setTime ");
 //      Swal.close();
 //           }
 //
 //      }, 2000);
 //        break;
 //      case 3:
 //      pingserver.src = "https://action.culturalgo.com/broker_08/wp-content/uploads/2021/03/Banner-principal-2-1536x431.jpg";
 //      if (pingserver.height>0) {
 //       } else {
 //         console.log(' no hace nada ');
 //
 //      }
 //      setTimeout(() => {
 //        pingserver.src = "https://action.culturalgo.com/broker_08/wp-content/uploads/2021/03/Banner-principal-2-1536x431.jpg";
 //        if (pingserver.height>0) {
 //          this.graphics04=true;
 //  Swal.close();
 //  this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');
 //        } else {
 //          console.log("no hace nada despues del setTime ");
 //      Swal.close();
 //
 //           }
 //
 //      }, 2000);
 //        break;
 //      case 4:
 //      pingserver.src = "https://culture04.culturalgo.com:8443/images/background.png";
 //      if (pingserver.height>0) {
 //
 //       } else {
 //         console.log(' no hace nada ');
 //
 //      }
 //      setTimeout(() => {
 //        pingserver.src = "https://culture04.culturalgo.com:8443/images/background.png";
 //        if (pingserver.height>0) {
 //         this.culture04=true;
 //           Swal.close();
 //           this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');
 //        } else {
 //          console.log("no hace nada despues del setTime ");
 //      Swal.close();
 //           }
 //
 //      }, 2000);
 //        break;
 //
 //      default:
 //        break;
 //    }
 // }



 async testConection(typeConec){
   this.modalConection();
   let url:any;
   switch (typeConec) {
     case 1: url='https://newsurvey.culturalgo.com';break;
     case 2: url='https://4all.gptw.global';break;
     case 3: url='https://success.culturalgo.com';break;
     case 4: url='https://culture04.culturalgo.com:8443/';break;
     default:
       break;
   }
     if(navigator.onLine ) {
       try {
         const response = await fetch(url,{ mode: 'no-cors'});
         console.log(response);
         if (response) {
           switch (typeConec) {
             case 1: this.newsurvey=true; Swal.close(); this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');break;
             case 2: this.forAllGptw=true; Swal.close(); this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');break;
             case 3: this.graphics04=true; Swal.close(); this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK');break;
             case 4: this.culture04=true; Swal.close(); this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_CONEX_OK'),'OK'); break;
             default:
               break;
           }
         }
         console.log(response);
         return response;

       } catch (error) {
         // switch (typeConec) {
         //   case 1: this.newsurveyNumIntentos++;
         //   if (this.newsurveyNumIntentos>=3) {
         //     this.btnMostrarHelpnewsurvey=true;
         //   }else{
         //     this.btnMostrarHelpnewsurvey=false;
         //   }
         //    Swal.close();
         //    break;
         //   case 2:
         //   this.forAllGptwNumIntentos++;
         //    if (this.forAllGptwNumIntentos>=3) {
         //      this.btnMostrarHelpforAllGptw=true;
         //    }else{
         //      this.btnMostrarHelpforAllGptw=false;
         //    }
         //    Swal.close();
         //     break;
         //   case 3:
         //   this.graphics04NumIntentos++;
         //               if (this.graphics04NumIntentos>=3) {
         //                 this.btnMostrarHelpgraphics04=true;
         //               }else{
         //                 this.btnMostrarHelpgraphics04=false;
         //               }
         //      Swal.close();
         //      break;
         //   case 4: this.culture04NumIntentos++;
         //       if (this.culture04NumIntentos>=3) {
         //         this.btnMostrarHelpculture04=true;
         //       }else{
         //         this.btnMostrarHelpculture04=false;
         //       }
         //   Swal.close();
         //   break;
         //   default:
         //     break;
         // }
         //
       }
  }
  }

  modalConection(){

    Swal.fire({
      imageUrl:'assets/WimaxTowerAnimation.gif',
      title: this.translateSrv.instant('REQUERIMIENTOSV3.COMPR_CONEXI'),
      allowOutsideClick: false,
      imageWidth: 100,
      imageHeight: 90,
      showConfirmButton:false

    });
  }

 openSuccessSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
       duration: 5000,
       panelClass: ['background-success']
    });
 }

 getInfoEmpresaExt(empresaId){
   this.reqService.getInfoEmpresa(empresaId).subscribe((respuesta:any) => {
     console.log("getInfoEmpresa:",respuesta);
     if(respuesta.success){
      this.idiomasRtInstituto=respuesta.instituo.toString();
     }
   });
 }

}
